import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DiscountTemplatesService } from '../discount-templates.service';
import { ControlItem, ProductTypesEnum } from 'src/app/models/frontend';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { ProductType } from 'src/app/models/enums';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-custmized-discount-templates',
  templateUrl: './create-custmized-discount-templates.component.html',
  styleUrls: ['./create-custmized-discount-templates.component.scss']
})
export class CreateCustmizedDiscountTemplatesComponent implements OnInit {

  @ViewChild('allDiscounts') discountsInput!: ElementRef<HTMLInputElement>; 
  @ViewChild('checkAllProducts') checkAllProducts!: ElementRef<HTMLInputElement>; 
  errors: string[] | null = [];
  eventForm: FormGroup
  @ViewChild('modal') modal: ElementRef;

  productType: ControlItem[] = [];
  countries: any
  countriesOption: ControlItem[] = []

  providers: any
  providersOption: ControlItem[] = []

  CountryIso: any
  CountryName: any
  ProviderCode: any
  ProviderName: any

  AllDiscountValues: number
  LogoURL: string

  Products: any
  ID: any

  productRequest = {
    countryIso: "",
    providerCode: "",
    receiveCountryName: "",
    providerName: "",
    accountNumber: "",
    logoUrl: "",
    logRequest: true
  }

  enabledRows: any[] = [];
  countryLoader = false
  providerLoader = false
  productLoader = false
  loader= false;

  constructor(public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    public activatedRoute: ActivatedRoute,
    public customSerivce: DiscountTemplatesService,
    public router: Router,private toastr:ToastrService) {

    this.activatedRoute.params.subscribe(params => { this.ID = params['id'].replace('id', '') });
    
    this.GetCountries()
    // this.GetProviders()
    this.productType = ProductTypesEnum

  }

  ngOnInit(): void {
    // this.eventForm = this.fb.group({
    //   Country: [''],
    //   ProductType: ['', [Validators.required]],
    //   ProviderCode: ['', [Validators.required, Validators.maxLength(100)]],
    //   ProductTitle: ['', [Validators.required, Validators.maxLength(100)]],
    //   SkuCode: ['', [Validators.required, Validators.maxLength(100)]],
    //   Amount: ['', [Validators.required, Validators.maxLength(100)]],
    //   PrideComissionPercentage: ['', [Validators.required]],
    //   DiscountPercentage: ['', [Validators.required]],
    //   DiscountTemplateName: ['', [Validators.required, Validators.maxLength(100)]],
    // });

  }
  closeModal() {
    this.activeModal.close({ refresh: true });
    }
  // Function to close the modal
  Close() {

  }
  async GetCountries() {
    this.countryLoader = true
    await this.customSerivce.GetCountries().subscribe((res: any) => {
      
      this.countries = res.items
      
      this.countryLoader = false
      for (let i = 0; i <= this.countries.length; i++) {
        this.countriesOption.push({ value: this.countries[i].countryIso, label: this.countries[i].countryName })
      }

    }
    )

    
  }
  GetProviders(id) {
    this.providerLoader = true
    
    this.CountryIso = id
    const selectedCountry = this.countriesOption.find(country => country.value === id);
    this.CountryName = selectedCountry.label
    this.providersOption = []
    this.customSerivce.GetProviders(id).subscribe((res: any) => {
      
      this.providers = res
      this.providerLoader = false
      for (let i = 0; i <= this.providers.length; i++) {
        this.providersOption.push({ value: this.providers[i].providerCode, label: this.providers[i].name, label2: this.providers[i].logoUrl })
      }
    })

  }

  GetProducts(id) {
    // this.productLoader = true
    
    if(id==""){

    }
    this.ProviderCode = id

    const selectedProviders = this.providersOption.find(provider => provider.value === id);
    
    this.ProviderName = selectedProviders.label
    this.LogoURL = selectedProviders.label2

    this.productRequest = {
      countryIso: this.CountryIso,
      providerCode: this.ProviderCode,
      receiveCountryName: "",
      providerName: "",
      accountNumber: "",
      logoUrl: "",
      logRequest: true
    }
    
    this.customSerivce.GetProducts(this.productRequest).subscribe((res: any) => {
    
      this.Products = res.result.items
      this.productLoader = false
    })

  }

  onSubmit(data, discountPercentage) {
    const productTypeNumber = parseInt("1", 10);
    const discountPer = parseFloat(discountPercentage)
    
    // if (!this.eventForm.valid) return this.eventForm.markAllAsTouched();
    this.eventForm = this.fb.group({
      ProductType: ProductType.InternationalTopUp,
      ProviderCode: this.ProviderCode,
      Country: this.CountryName,
      ProviderName: this.ProviderName,
      ProductTitle: data.defaultDisplayText,
      SkuCode: data.skuCode,
      Amount: data.maximum.sendValue,
      PrideComissionPercentage: data.commissionRate,
      DiscountPercentage: discountPer,
      DiscountTemplateId: this.customSerivce.templateId,
      IsActive: true
    })
    
    this.customSerivce.CreateDiscountTemplateCustomized(this.eventForm.value)
      .subscribe({

        next: r => {
          this.toastr.success('Created','Success');
          // this.activeModal.close({ refresh: true });
        },
        // error: e => {
        
        //   alert("400 Bad Request")
          error: e => {
            if (e.error.message) {
              this.toastr.error('Oops!', e.error.message);
            }
            else {
              this.toastr.error('Oops!', "Something went wrong");
            }
          }
        
      })

  }

  SubmitAll(value) {
    this.loader=true;
    
    for(let i=0;i<this.Products.length;i++){
      this.AddAllDiscountToArray(value,this.Products[i])
    }
    const productTypeNumber = parseInt("1", 10);
    
    for (let i = 0; i < this.enabledRows.length; i++) {
      
      const discountPer = parseFloat(this.enabledRows[i].DiscountPercentage)
      const templateId = parseInt(this.customSerivce.templateId, 10)
      this.eventForm = this.fb.group({
        ProductType: ProductType.InternationalTopUp,
        ProviderCode: this.ProviderCode,
        Country: this.CountryName,
        ProviderName: this.ProviderName,
        ProductTitle: this.enabledRows[i].ProductTitle,
        SkuCode: this.enabledRows[i].SkuCode,
        Amount: this.enabledRows[i].Amount,
        PrideComissionPercentage: this.enabledRows[i].PrideComissionPercentage,
        DiscountPercentage: discountPer,
        DiscountTemplateId: templateId,
        IsActive: true
      })
      
      this.customSerivce.CreateDiscountTemplateCustomized(this.eventForm.value)
        .subscribe({
          next: r => {
            debugger
            if (this.discountsInput)
              this.discountsInput.nativeElement.value = '';
              // this.providersOption=[];
              this.Products=[];
              this.enabledRows=[];
            if(this.checkAllProducts)
              this.checkAllProducts.nativeElement.checked=false;
            this.toastr.success('Created','Success');
            //  this.activeModal.close({ refresh: true });
          },
          error: e => this.errors = e.error?.errors || [e.error?.message],
          complete:()=>{this.loader=false;}
        })

    }
  }

  allValuesDiscount(value) {
    
    this.AllDiscountValues = value
  }

  toggleRow(discount, checked) {
    // discount.enabled = !discount.enabled;
    discount.enabled = checked.checked;
    
    const index = this.enabledRows.findIndex(row => row.SkuCode === discount.skuCode);
    if (index !== -1) {
      this.enabledRows.splice(index, 1);
    }

  }
  addToArray(discount: any, discountPercentage) {
    this.enabledRows.push({
      ProductTitle: discount.defaultDisplayText,
      SkuCode: discount.skuCode, Amount: discount.maximum.sendValue,
      PrideComissionPercentage: discount.commissionRate,
      DiscountPercentage: discountPercentage
    })
  }

  deleteItem(item) {
    const index = this.enabledRows.findIndex(row => row === item);
    if (index !== -1) {
      this.enabledRows.splice(index, 1);
      item.enabled = !item.enabled
    }
  }
  AddDiscountToArray(value, discount) {
    
    const index = this.enabledRows.findIndex(row => row.skuCode === discount.SkuCode);
    
    if (index !== -1) {
      this.enabledRows[index] = {
        ProductTitle: discount.defaultDisplayText,
        SkuCode: discount.skuCode, Amount: discount.maximum.sendValue,
        PrideComissionPercentage: discount.commissionRate,
        DiscountPercentage: value
      }
    }
    else {
      this.enabledRows.push({
        ProductTitle: discount.defaultDisplayText,
        SkuCode: discount.skuCode, Amount: discount.maximum.sendValue,
        PrideComissionPercentage: discount.commissionRate,
        DiscountPercentage: value
      })
    }


    
  }
  AddAllDiscountToArray(value, discount) {
    
      this.enabledRows.push({
        ProductTitle: discount.defaultDisplayText,
        SkuCode: discount.skuCode, 
        Amount: discount.maximum.sendValue,
        PrideComissionPercentage: discount.commissionRate,
        DiscountPercentage: value
      })
    
  }
  toggleAllRows(event: any) {
    const isChecked = event.target.checked;
    this.Products.forEach(discount => discount.enabled = isChecked);
    
}
  allRowsChecked(): boolean {
    return this.Products.every(discount => discount.enabled);

  }
}

